import React from 'react';

const GreenTickBig = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="green-tick-big-icon"
  >
    <g id="Group 11">
      <circle id="Oval" cx="24" cy="24" r="24" fill="#00A331" />
      <path
        id="Shape"
        d="M30.2084 17.0657L20.8004 26.4737L17.7924 23.4657C17.1684 22.8417 16.1604 22.8417 15.5364 23.4657C14.9124 24.0897 14.9124 25.0977 15.5364 25.7217L19.6804 29.8657C20.3044 30.4897 21.3124 30.4897 21.9364 29.8657L32.4804 19.3217C33.1044 18.6977 33.1044 17.6897 32.4804 17.0657C31.8564 16.4417 30.8324 16.4417 30.2084 17.0657Z"
        fill="white"
      />
    </g>
  </svg>
);
export default GreenTickBig;
